"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_ROOM_AMENITIES = exports.ICON_RATES_AMENITIES = exports.ICON_MAPPER = void 0;
const ICON_MAPPER = exports.ICON_MAPPER = {
  1: 'WifiIcon',
  2: 'PoolIcon',
  3: 'FitnessCenterIcon',
  4: 'SpaIcon',
  5: 'WavesIcon',
  6: 'AirportShuttleIcon',
  7: 'SmokingRoomsIcon',
  8: 'SmokeFreeIcon',
  9: 'RestaurantIcon',
  10: 'PoolsideBar',
  11: 'LocalCafeIcon',
  12: 'LocalBarIcon',
  13: 'SportsTennisIcon',
  14: 'HotTubIcon',
  15: 'NightclubIcon',
  16: 'LocalParkingIcon',
  17: 'RoomServiceIcon',
  18: 'LocalLaundryServiceIcon',
  19: 'LuggageStorageIcon',
  20: 'BusinessCenterIcon',
  21: 'GardenIcon',
  22: 'ConciergeServicesIcon'
};
const ICON_ROOM_AMENITIES = exports.ICON_ROOM_AMENITIES = {
  4: 'SmokeFreeIcon',
  5: 'SmokingRoomsIcon',
  6: 'HotTubIcon',
  7: 'Balcony',
  8: 'TvIcon',
  9: 'AcUnitIcon',
  10: 'CallToActionIcon',
  // min bar
  11: 'Toiletries',
  12: 'RoomServiceIcon',
  13: 'FreeBottledWater',
  14: 'BathtubIcon',
  15: 'ViewCompactIcon',
  // Desk
  16: 'HairDryer',
  17: 'KitchenIcon',
  18: 'Microwave',
  19: 'PhoneIcon'
};
const ICON_RATES_AMENITIES = exports.ICON_RATES_AMENITIES = {
  1: 'WifiIcon',
  2: 'RestaurantIcon',
  3: 'LocalParkingIcon',
  20: 'WifiIcon',
  21: 'WifiIcon',
  22: 'RestaurantIcon',
  23: 'RestaurantIcon',
  24: 'RestaurantIcon',
  25: 'RestaurantIcon',
  26: 'RestaurantIcon',
  27: 'RestaurantIcon',
  28: 'RestaurantIcon',
  29: 'RestaurantIcon',
  30: 'RestaurantIcon',
  31: 'RestaurantIcon',
  32: 'RestaurantIcon',
  33: 'RestaurantIcon',
  34: 'LocalDrinkIcon',
  35: 'AirportShuttleIcon',
  36: 'AirportShuttleIcon',
  37: 'AirportShuttleIcon',
  38: 'RvHookupIcon',
  39: 'LocalCafeIcon',
  40: 'WineBottle',
  // static
  41: 'StarsIcon',
  42: 'AccessTimeIcon',
  43: 'AccessTimeIcon',
  44: 'AssistantIcon',
  45: 'AssistantIcon',
  46: 'WineBottle',
  47: 'AssistantIcon',
  48: 'StarsIcon',
  49: 'StarsIcon',
  50: 'StarsIcon',
  51: 'StarsIcon',
  52: 'TouchAppIcon',
  53: 'PlaylistAddCheckIcon',
  54: 'AssistantIcon',
  55: 'DirectionsBoat',
  56: 'DirectionsBoat',
  57: 'AssistantIcon',
  58: 'StarsIcon',
  59: 'AccessTimeIcon',
  60: 'AccessTimeIcon',
  61: 'AssistantIcon',
  62: 'Liquor',
  // not getting from MI
  63: 'LooksIcon',
  64: 'WifiIcon',
  65: 'RestaurantIcon',
  66: 'LocalParkingIcon',
  67: 'VideoLabelIcon',
  68: 'PlaylistAddCheckIcon',
  70: 'RestaurantIcon',
  71: 'RestaurantIcon',
  72: 'RestaurantIcon',
  73: 'RestaurantIcon',
  74: 'RestaurantIcon',
  75: 'SetMeal'
};